//import LoginForm from "../login/loginForm";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { submit } from "../../../features/forms/form6";
// import SubmitForm from "../../forms/form6/submitbutton/submitForm";
import { useForm, FormProvider } from "react-hook-form";
import SignupForm from "./SignupForm";
import { useNavigate } from "react-router-dom";
import "../login.css";
import Footer from "../footer";
import Intro from "../intro";
// import "../signup.css"

function Signup() {
    let navigate = useNavigate();
    // const [exceedError, setExceedError] = useState(false);
    const methods = useForm();
    const { register, handleSubmit, reset, errors } = methods;
    const dispatch = useDispatch();
    // const submitLoginForm = (data, e) => {
    //   e.preventDefault();
    //   dispatch(submit(data));
    //   reset();
    // };
    const [signUpObj, setSignUpObj] = useState({
        mobile_number: "",
        email: "",
        captcha: "",
    });
    const handlesubmit = (event) => {
        event.preventDefault();
        if(signUpObj.mobile_number !==null){
        navigate("/otp", { state: signUpObj.mobile_number });
        }
        else if(signUpObj.email !==null){
            navigate("/emailotp", { state: signUpObj.mobile_number });
        }
    };
    return (
        // <div className="container-fluid" id="signup">
        //     <div className="row layout"  >
        //         <div className="col-md-5 dummy_box ">

        //         <div className="dummy_text">
        //         <div className="heading">
        //             img
        //             Web Portal
        //         </div>
        //         <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an</p>
        //         <span>Home</span>
        //         <span>About Us</span>
        //         <span>Contact Us</span>

        //         </div>
        //         <div className="footer">
        //         Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an
        //         </div>
        //         </div>
        //         <div className="col-md-7 form" >
        //             <div className="row p-2">
        //             <div className="form">
        //                 {/* <FormProvider {...methods} > 
        //                 <form  onSubmit={handleSubmit(submitLoginForm)}> 
        //                     <SignupA></SignupA>
        //                </form>
        //               </FormProvider > */}  
        //                 <SignupA/>
        //               </div>
        //               </div>
        //         </div>
        //     </div>
        // </div>

        <div className="container-fluid" id="signUp">
            <div className="row layout">
                <div className="col-sm-5 login-content-box-wrapper">
                    <div className="login-content-box">
                        <Intro></Intro>
                        <div className="footer_login">
                            <Footer></Footer>
                        </div>
                    </div>

                </div>
                <div className="col-sm-7 form-login-wrapper">
                    <div className="form_login">
                        <form onSubmit={handlesubmit} className="form_align">
                            <SignupForm
                                signUpObj={signUpObj}
                                setSignUpObj={setSignUpObj}
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Signup;